import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import useStyles from './sampleDevelopmentNl.style';

import { CheckBoxFastField, TextFieldFastField } from '../../../components';

interface SamDevNlDesignSoftwareProps {
  isCrtLocked?: boolean;
}

const SampleDevelopmentNlDesignSoftware: React.FC<SamDevNlDesignSoftwareProps> = (
  props,
) => {
  const { isCrtLocked = false } = props;
  const classes = useStyles();
  return (
    <Grid
      container
      spacing={1}
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
    >
      <Typography className={classes.numberTitle} display="inline">
        4. Software
      </Typography>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={12} md={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="softwareAcrobat"
            label="Acrobat"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="softwareAcrobatData"
            label="Acrobat"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="softwareIllustrator"
            label="Illustrator"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="softwareIllustratorData"
            label="Illustrator"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="softwarePageMaker"
            label="Page Maker"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="softwarePageMakerData"
            label="Page Maker"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="softwarePhotoshop"
            label="Photoshop"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="softwarePhotoshopData"
            label="Photoshop"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <CheckBoxFastField
            disabled={isCrtLocked}
            name="softwareFreeHand"
            label="Free Hand"
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="softwareFreeHandData"
            label="Free Hand"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="softwareQuark" label="Quark" />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            name="softwareQuarkData"
            label="Quark"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={2}>
          <CheckBoxFastField disabled={isCrtLocked} name="softwareEtc" label="Etc" />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextFieldFastField
            disabled={isCrtLocked}
            className={classes.textInputRightCheckbox}
            name="softwareEtcData"
            label="Etc"
            variant="outlined"
            margin="dense"
            fullWidth
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SampleDevelopmentNlDesignSoftware;
